import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { DumboProps as Props } from '../types';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import { getDeviationTitle, styleFromWidthHeight } from '../../_helpers';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import s from './Literature.scss';

const typeMap = {
  ANTFART: 'antfart', // CR27/CR27M Small group and collection card
  NANO: 'nano', // CR06A-E - Gallery Folder Thumbnail
  SMALL: 'small', // CR06A-E - Gallery Folder Thumbnail
  MEDIUM: 'medium', // CR40 - Literature Box - 3 lines of text and 2 lines of title
  BIG: 'big', // CR40 - Literature Box
};

// not sure about the correct approach, I used the comparison with the area, as there were no breakpoints for height and width
export const typeSizeMap = {
  ANTFART: 66,
  NANO: 150,
  SMALL: 214,
  MEDIUM: 250,
  BIG: 280,
};

function getTypeBasedOnSize(size) {
  if (size <= typeSizeMap.ANTFART) {
    return typeMap.ANTFART;
  }
  if (size <= typeSizeMap.NANO) {
    return typeMap.NANO;
  }
  if (size <= typeSizeMap.SMALL) {
    return typeMap.SMALL;
  }
  if (size > typeSizeMap.BIG) {
    return typeMap.BIG;
  }
  return typeMap.MEDIUM;
}

const LiteratureDumbView: React.FC<Props> = ({
  deviation,
  width,
  height,
  useTextlessMode,
  responsive = true,
  className,
  coverLetterClassName,
  'aria-hidden': ariaHidden,
}) => {
  const { t } = useTranslation();
  const type = getTypeBasedOnSize(height);
  const deviationTitle = getDeviationTitle(deviation);
  const style = styleFromWidthHeight({ width, height }, responsive);
  const isBigEnough = Number(style.height || 0) > typeSizeMap.ANTFART;

  return (
    <Section
      className={classnames(s['root'], s[type], className)}
      style={style}
      aria-hidden={ariaHidden}
    >
      <LiteratureCoverLetter
        title={deviationTitle}
        isBigEnough={isBigEnough}
        className={coverLetterClassName}
      />
      {!useTextlessMode && (
        <>
          <div className={s['tag']}>{t('deviationview.literature.tag')}</div>
          <Heading className={s['title']}>{deviationTitle}</Heading>
          <ExcerptRenderer
            className={s['text-content']}
            textContent={deviation.textContent}
            htmlExcerptLegacy
          />
        </>
      )}
    </Section>
  );
};

LiteratureDumbView.displayName = 'LiteratureDumbView';

export default LiteratureDumbView;
